import {
	Row,
	Col,
	Table,
	Button,
	Tag,
	Tooltip,
	Flex,
	Drawer,
	Typography,
	Form,
	Checkbox,
} from "antd";

import {
	TableDropdownFilter,
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
} from "../../../providers/CustomTableFilter";
import ModalUploadOR from "./components/ModalUploadOR";
import ModalFormORValidation from "./components/ModalFormORValidation";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GET } from "../../../providers/useAxiosQuery";
import PreferredExamCalendar from "./components/PreferredExamCalendar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

export default function PageApplicantPayments() {
	const location = useLocation();

	const [openDrawerFilter, setOpenDrawerFilter] = useState(false);
	const [examScheduleFilter, setExamScheduleFilter] = useState([]);
	const [form] = Form.useForm();

	const [toggleModalUploadOR, setToggleModalUploadOR] = useState({
		open: false,
		data: null,
	});

	const [
		toggleModalFormORValidation,
		setToggleModalFormORValidation,
	] = useState({
		open: false,
		data: null,
	});

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "created_at",
		sort_order: "desc",
		exam_schedule_id: "",
		payment_status: "",
		from: "Payment Approval List View",
		status: "Active",
		category: ["College", "College of Law", "Graduate Studies"],
	});

	useEffect(() => {
		setTableFilter({
			page: 1,
			page_size: 50,
			search: "",
			sort_field: "created_at",
			sort_order: "desc",
			exam_schedule_id: "",
			payment_status: "Not Paid",
			from: "Payment Approval List View",
			status: "Active",
			category: ["College", "College of Law", "Graduate Studies"],
		});

		return () => {};
	}, [location]);

	const {
		data: dataStudentExam,
		refetch: refetchStudentExam,
	} = GET(
		`api/student_exams?${new URLSearchParams(tableFilter)}`,
		"student_exams_list",
		(res) => {}
	);

	const { data: dataExamCategory } = GET(
		`api/exam_category`,
		"exam_category_list"
	);

	useEffect(() => {
		refetchStudentExam();

		if (tableFilter.exam_schedule_id !== "All") {
			const examSchedule = dataStudentExam?.dataExamSchedules?.find(
				(item) => item.id === tableFilter.exam_schedule_id
			);

			setExamScheduleFilter(examSchedule);
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter, setExamScheduleFilter]);

	return (
		<>
			<Row gutter={[12, 12]} id="tbl_wrapper_approval">
				<Col xs={24} sm={24} md={24} lg={24}>
					<div className="tbl-top-filter">
						<Flex vertical gap={10}>
							<Flex gap={10}>
								<Flex gap={10}>
									<Button
										type="primary"
										onClick={() => {
											setTableFilter((ps) => ({
												...ps,
												exam_schedule_id: "All",
											}));
										}}
									>
										View All Scheduled
									</Button>

									<TableDropdownFilter
										items={
											dataExamCategory &&
											dataExamCategory.data && [
												{
													key: "exam_schedule_id",
													label: (
														<Flex justify="space-between" align="center">
															<Button
																type="text"
																color="default"
																className="pl-0 btn-filter-exam-schedule"
																onClick={() => setOpenDrawerFilter(true)}
															>
																Exam Schedule
															</Button>
															<FontAwesomeIcon icon={faChevronRight} />
														</Flex>
													),
												},
												{
													key: "category",
													label: "Exam Category",
													children: dataExamCategory.data.map((item) => {
														const isChecked =
															tableFilter?.category?.includes(item.category) ||
															false;

														const handleCheckboxChange = (e) => {
															let updatedCategory = tableFilter?.category || [];
															if (e.target.checked) {
																if (!updatedCategory.includes(item.category)) {
																	updatedCategory.push(item.category);
																}
															} else {
																updatedCategory = updatedCategory.filter(
																	(f) => f !== item.category
																);
															}

															setTableFilter((prevState) => ({
																...prevState,
																category: updatedCategory,
															}));
														};

														return {
															key: item.id.toString(),
															label: (
																<div>
																	<Checkbox
																		id={`chck_${item.category}`}
																		checked={isChecked}
																		onChange={handleCheckboxChange}
																	/>
																	<label htmlFor={`chck_${item.category}`}>
																		{item.category}
																	</label>
																</div>
															),
														};
													}),
												},
											]
										}
									/>
								</Flex>

								{tableFilter.exam_schedule_id !== "All" && examScheduleFilter && (
									<Flex gap={20} align="center">
										<Typography.Title level={5} className="m-0">
											<span style={{ fontWeight: "normal" }}>Date:</span>{" "}
											<span className="pr-20" style={{ color: "#447ce2" }}>
												{examScheduleFilter
													? dayjs(examScheduleFilter.exam_date).format(
															"MMMM DD, YYYY"
													  )
													: "???"}
											</span>
											<span style={{ fontWeight: "normal" }}>Time:</span>{" "}
											<span className="pr-20" style={{ color: "#447ce2" }}>
												{examScheduleFilter ? (
													<>
														{examScheduleFilter.time_in}{" "}
														{examScheduleFilter.time_in_meridiem} -{" "}
														{examScheduleFilter.time_out}{" "}
														{examScheduleFilter.time_out_meridiem}
													</>
												) : (
													"???"
												)}
											</span>
											<span style={{ fontWeight: "normal" }}>
												Available Slot/s:
											</span>{" "}
											<span className="pr-20" style={{ color: "#447ce2" }}>
												{examScheduleFilter
													? examScheduleFilter.total_available_slot
													: "???"}
											</span>
										</Typography.Title>
									</Flex>
								)}
							</Flex>

							<Flex gap={10}>
								<Button
									type={
										tableFilter.payment_status === "Not Paid"
											? "primary"
											: "default"
									}
									onClick={() => {
										setTableFilter((ps) => ({
											...ps,
											payment_status: "Not Paid",
										}));
									}}
									className={
										tableFilter.payment_status === "Not Paid" &&
										"btn-main-primary"
									}
								>
									Not Paid
								</Button>

								<Button
									type={
										tableFilter.payment_status === "Paid"
											? "primary"
											: "default"
									}
									onClick={() => {
										setTableFilter((ps) => ({
											...ps,
											payment_status: "Paid",
										}));
									}}
									className={
										tableFilter.payment_status === "Paid" && "btn-main-primary"
									}
								>
									Paid
								</Button>

								<TableGlobalSearchAnimated
									tableFilter={tableFilter}
									setTableFilter={setTableFilter}
								/>
							</Flex>
						</Flex>

						<Flex vertical gap={12} align="flex-end">
							<TablePageSize
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
							/>

							<Flex className="tbl-bottom-filter">
								<div />

								<Flex>
									<TableShowingEntriesV2 />
									<TablePagination
										tableFilter={tableFilter}
										setTableFilter={setTableFilter}
										setPaginationTotal={dataStudentExam?.data?.total}
										showLessItems={true}
										showSizeChanger={false}
										tblIdWrapper="tbl_wrapper_approval"
									/>
								</Flex>
							</Flex>
						</Flex>
					</div>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24}>
					<Table
						id="tblPayment"
						className="ant-table-default ant-table-striped"
						dataSource={dataStudentExam && dataStudentExam.data.data}
						rowKey={(record) => record.id}
						pagination={false}
						bordered={false}
						scroll={{ x: "max-content" }}
						sticky
					>
						<Table.Column
							title="Action"
							key="action"
							dataIndex="action"
							align="center"
							width={100}
							render={(text, record) => {
								let isPaid = record.payment_status;

								return (
									<Tooltip title={isPaid === "Paid" ? "View OR" : "Upload OR"}>
										<Button
											type="primary"
											className="primary-color"
											name="btn_edit"
											onClick={() => {
												setToggleModalUploadOR({
													open: true,
													data: record,
												});
											}}
										>
											{isPaid === "Paid" ? "View OR" : "Upload OR"}
										</Button>
									</Tooltip>
								);
							}}
						/>

						{tableFilter.payment_status === "Not Paid" && (
							<>
								<Table.Column
									title="Payment Approval List View"
									key="payment_status"
									dataIndex="payment_status"
									width={200}
									render={(text, record) => {
										return (
											<Tooltip
												title={
													record.or_number === null
														? "No OR Attached"
														: "For Validation"
												}
											>
												<Button
													type={
														record.or_number === null ? "dashed" : "primary"
													}
													className="primary-color"
													name="btn_edit"
													onClick={() => {
														setToggleModalFormORValidation({
															open: true,
															data: record,
														});
													}}
													disabled={record.or_number === null}
												>
													{record.or_number === null
														? "No OR Attached"
														: "For Validation"}
												</Button>
											</Tooltip>
										);
									}}
								/>

								<Table.Column
									title="Notes"
									key="payment_notes"
									dataIndex="payment_notes"
									width={200}
								/>
							</>
						)}

						{tableFilter.payment_status === "Paid" && (
							<Table.Column
								title="Official Receipt"
								key="or_number"
								dataIndex="or_number"
								sorter={(a, b) => a.or_number - b.or_number}
								width={250}
							/>
						)}

						<Table.Column
							title="Student Name"
							key="fullname"
							dataIndex="fullname"
							sorter={(a, b) => a.fullname.localeCompare(b.fullname)}
							width={200}
						/>

						<Table.Column
							title="Exam Schedule"
							key="exam_schedule_id"
							dataIndex="exam_schedule_id"
							sorter={(a, b) => a.exam_category.localeCompare(b.exam_category)}
							defaultSortOrder="ascend"
							width={300}
							render={(text, record) => (
								<>
									{dayjs(record.exam_date).format("MMMM DD, YYYY")} ({" "}
									{record.exam_time} )
								</>
							)}
						/>

						<Table.Column
							title="Exam Category"
							key="exam_category_id"
							dataIndex="exam_category_id"
							width={200}
							sorter={(a, b) => a.exam_category.localeCompare(b.exam_category)}
							render={(text, record) => (
								<>
									{record.exam_category}{" "}
									<Tag color="blue" style={{ fontSize: "12px" }}>
										₱ {record.exam_fee}.00
									</Tag>
								</>
							)}
						/>

						<Table.Column
							title="Payment Status"
							key="payment_status"
							dataIndex="payment_status"
							sorter={(a, b) => a.payment_status - b.payment_status}
							width={150}
							render={(text, record) => {
								return (
									<Tag
										color={
											record.payment_status === "Not Paid" ? "#f50" : "#87d068"
										}
										style={{ fontSize: "12px" }}
									>
										{record.payment_status}
									</Tag>
								);
							}}
						/>
					</Table>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<Flex className="tbl-bottom-filter">
						<div />

						<Flex>
							<TableShowingEntriesV2 />
							<TablePagination
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
								setPaginationTotal={dataStudentExam?.data?.total}
								showLessItems={true}
								showSizeChanger={false}
								tblIdWrapper="tbl_wrapper_approval"
							/>
						</Flex>
					</Flex>
				</Col>
			</Row>

			<Drawer
				title={
					<div style={{ textAlign: "right" }}>Filter by Exam Schedule</div>
				}
				onClose={() => {
					setOpenDrawerFilter(false);
				}}
				open={openDrawerFilter}
				size="large"
				width="800px"
				id="PageApplicant"
			>
				<PreferredExamCalendar
					dataStudentExam={dataStudentExam}
					setTableFilter={setTableFilter}
				/>
			</Drawer>

			<ModalUploadOR
				toggleModalUploadOR={toggleModalUploadOR}
				setToggleModalUploadOR={setToggleModalUploadOR}
				setToggleModalFormORValidation={setToggleModalFormORValidation}
				tableFilter={tableFilter}
			/>

			<ModalFormORValidation
				toggleModalFormORValidation={toggleModalFormORValidation}
				setToggleModalFormORValidation={setToggleModalFormORValidation}
				tableFilter={tableFilter}
				form={form}
			/>
		</>
	);
}
